export default __webpack_public_path__ + "static/media/Paul Jenning.3d619970.png";